export default "__VITE_ASSET__3a40eef4__"